export const DEFAULT_BRANCH_ID = "CBE001";

export const BRANCH_STORAGE_KEY = "tt_branch_id";
export const BRANCH_CHANNEL = "tt_branch_channel";

export const FORM_DIRTY_PREFIX = "tt_form_dirty:";

const BRANCH_ID_SHAPE = /^[A-Z]{3}\d{3}$/;

export const getBranchId = (): string => {
    try {
        const stored =
            localStorage.getItem(BRANCH_STORAGE_KEY) ||
            localStorage.getItem("branchid") ||
            localStorage.getItem("BranchId");

        return stored && BRANCH_ID_SHAPE.test(stored) ? stored : DEFAULT_BRANCH_ID;
    } catch {
        return DEFAULT_BRANCH_ID;
    }
};
export const setBranchId = (id: string, senderId?: string): void => {
    try {
        localStorage.setItem(BRANCH_STORAGE_KEY, id);
    } catch {
    }

    try {
        const channel = new BroadcastChannel(BRANCH_CHANNEL);
        channel.postMessage({
            type: "BRANCH_CHANGE",
            branchId: id,
            senderId,
            timestamp: Date.now(),
        });
        setTimeout(() => {
            try {
                channel.close();
            } catch {
            }
        }, 1000);
    } catch {
    }
};

export const clearBranchId = (): void => {
    try {
        localStorage.removeItem(BRANCH_STORAGE_KEY);
    } catch {
    }
};

export const hasDirtyForm = (): boolean => {
    try {
        return Object.keys(localStorage).some((k) =>
            k.startsWith(FORM_DIRTY_PREFIX)
        );
    } catch {
        return false;
    }
};

export const markFormDirty = (key: string): void => {
    try {
        localStorage.setItem(FORM_DIRTY_PREFIX + key, String(Date.now()));
    } catch {
    }
};

export const clearFormDirty = (key: string): void => {
    try {
        localStorage.removeItem(FORM_DIRTY_PREFIX + key);
    } catch {
    }
};
